import script from "./donateCase.vue?vue&type=script&setup=true&lang=js"
export * from "./donateCase.vue?vue&type=script&setup=true&lang=js"

import "./donateCase.vue?vue&type=style&index=0&id=1afd7b8c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1afd7b8c"]])

export default __exports__